// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardContainer_container__i4N9X","link":"ProductCardContainer_link__2Ulm3"};